import './DateRangeMapFilter.scss'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import { PickerValue } from '@mui/x-date-pickers/internals';
import { TextField } from '@mui/material';


interface IDateRangeMapFilterProps {
    label: string
    value: string | null
    valueChanged: (value: string) => void
}

const DateRageMapFilter = (props: IDateRangeMapFilterProps) => {

    const [fromDateValue, setFromDateValue] = useState<Dayjs | null>(null)
    const [toDateValue, setToDateValue] = useState<Dayjs | null>(null)
    const [validationError, setValidationError] = useState<string | null>(null)

    useEffect(() => {
        if(props.value){
            if(props.value.includes("|")){
                const splitValue = props.value.split("|")
                if(splitValue[0] !== "")
                    setFromDateValue(dayjs(splitValue[0]))
                if (splitValue[1] !== "")
                    setToDateValue(dayjs(splitValue[1]))
            } else {
                setFromDateValue(dayjs(props.value))
            }
        } else {
            setFromDateValue(null)
            setToDateValue(null)
        }
    }, [props.value])

    const handleValueChange = (dateId: "from" | "to", e: PickerValue) => {
        let currentFrom = fromDateValue
        let currentTo = toDateValue
        setValidationError(null)
        if (dateId === 'from'){
            setFromDateValue(e)
            currentFrom = e
        }
        else if (dateId === 'to'){
            setToDateValue(e)
            currentTo = e

            if (e && currentFrom !== null && currentFrom > e){
                setValidationError("From value cannot be greater than To value")
                setToDateValue(null)
            }
        }
        if (validationError === null){
            const stringValue = `${currentFrom?.format('YYYY-MM-DD') || ''}|${currentTo?.format('YYYY-MM-DD') || ''}`
            props.valueChanged(stringValue)
        }
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            {props.label}:
            <div className='map-filter-date-range-wrapper'>
                <div className='map-date-filter'>
                    <span className='date-label'>From:</span>
                    <DatePicker 
                        value={fromDateValue} 
                        onChange={(e) => handleValueChange('from', e)}
                        slots={{ textField: TextField }}
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                variant: "outlined",
                                sx:{
                                    "& .MuiInputAdornment-root svg": {
                                        color: (theme) => theme.palette.text.primary,
                                    },
                                }
                            },
                        }}
                        enableAccessibleFieldDOMStructure={false}
                    />
                </div>
                <div className='map-date-filter'>
                    <span className='date-label'>To:</span>
                    <DatePicker 
                        value={toDateValue} 
                        onChange={(e) => handleValueChange('to', e)}
                        slots={{ textField: TextField }}
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                variant: "outlined",
                                sx:{
                                    "& .MuiInputAdornment-root svg": {
                                        color: (theme) => validationError !== null ? theme.palette.error.main : theme.palette.text.primary,
                                    },
                                },
                                error:validationError !== null,
                                helperText:validationError
                            },
                        }}
                        enableAccessibleFieldDOMStructure={false}
                    />
                </div>
            </div>
        </LocalizationProvider>
    )
}

export default DateRageMapFilter